import Vue from 'vue'
import Router from 'vue-router'

import mainPage from '@/pagesPc/main/mainPage'
import login from '@/pagesPc/main/login'
import err from '@/pagesPc/main/err'
import report from '@/pagesPc/main/report'
import addTeam from '@/pagesPc/main/addTeam'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'mainPage',
      component: mainPage
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/err',
      name: 'err',
      component: err
    },
    {
      path: '/report',
      name: 'report',
      component: report
    },
    {
      path: '/addTeamMember',
      name: 'addTeamMember',
      component: addTeam
    }
    /* {
      path: '/calendar2',
      name: 'Calendar2',
      component: Calendar2
    },
    {
      path: '/calendar3',
      name: 'Calendar3',
      component: Calendar3
    } */
  ]
})



// WEBPACK FOOTER //
// ./src/router/pc_index.js